module.exports = __webpack_public_path__ + "static/media/howto.825ec3c7.svg";